import { useAuth } from '@/context/AuthContext';
import { useLocation } from 'react-router-dom';
import { canNavigate } from './navigation';

// Home and Career always use the released design. The legacy design is no longer user-selectable.
export const REFERENCE_FLAG = 'redesign_v2';

export function referenceEligible(user) {
  return Boolean(user?.id) && !user?.admin_mode &&
    ['mitarbeiter','teamleiter','vertriebspartner','admin'].includes(user?.role) &&
    canNavigate(user, '/m/home');
}

export function referenceEnabled(user, _search, _storage, pathname = '/m/home') {
  if (pathname === '/m/career') return careerPreviewEnabled(user);
  return pathname === '/m/home' && referenceEligible(user);
}

export function careerPreviewEnabled(user) {
  return referenceEligible(user) && canNavigate(user, '/m/career');
}

export function useReferencePreview() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  return referenceEnabled(user, '', undefined, pathname);
}
